export enum UserRole {
  NURSE = 'NURSE',
  DOCTOR = 'DOCTOR',
  ACCOUNTANT = 'ACCOUNTANT',
}
